import { createContext, useContext, useState, useCallback } from 'react';

/**
 * Режим темы Nova (dark | light).
 * Единственный источник правды: значение вешается атрибутом data-nova-mode
 * на корень шелла, а вся палитра переключается токенами в NovaApp.module.sass.
 * Компонентам, которым нужны цвета в JS (график), режим доступен через хук.
 */
const STORAGE_KEY = 'nova-mode';

const NovaThemeContext = createContext({ mode: 'dark', toggleMode: () => {} });

export function useNovaTheme() {
    return useContext(NovaThemeContext);
}

export function useNovaModeState() {
    const [mode, setMode] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved === 'light' || saved === 'dark') return saved;
        } catch (_) { /* приватный режим и т.п. */ }
        return 'dark';
    });

    const toggleMode = useCallback(() => {
        setMode(prev => {
            const next = prev === 'dark' ? 'light' : 'dark';
            try { localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* noop */ }
            return next;
        });
    }, []);

    return { mode, toggleMode };
}

export default NovaThemeContext;
